export { useMedicalDocumentView } from './useMedicalDocumentView';
